<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="indicatorSelectModalLabel">
      <div class="bootstrap-dialog-title">{{ title }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <input
      type="text"
      class="search-input"
      placeholder="Search {{ itemNoun }}..."
      [(ngModel)]="searchTerm"
    />

    <div class="list-toolbar">
      <span class="count-lbl">{{ limitLabel }}</span>
      <div class="list-toolbar-actions">
        <button
          type="button"
          class="clear-btn"
          (click)="toggleAllFiltered()"
          [disabled]="!filteredItems.length"
        >
          {{ allFilteredSelected ? 'Deselect all' : 'Select all' }}
        </button>
        <span class="toolbar-divider"></span>
        <button type="button" class="clear-btn" (click)="clearAll()" [disabled]="!selectedCount">
          Clear all
        </button>
      </div>
    </div>

    <p class="limit-note" *ngIf="maxSelection && limitReached">
      Maximum of {{ maxSelection }} {{ itemNoun }} reached. Deselect one to choose another.
    </p>

    <div class="indicators-list" #indicatorsList *ngIf="filteredItems.length; else noItemsFound">
      <label
        class="indicator-row"
        *ngFor="let item of filteredItems"
        [class.is-selected]="isSelected(item)"
        [class.is-disabled]="isDisabled(item)"
        [title]="item.name"
      >
        <input
          type="checkbox"
          class="chkOverview"
          [checked]="isSelected(item)"
          [disabled]="isDisabled(item)"
          (change)="toggle(item)"
        />
        <span class="indicator-text">
          <span class="node-name">
            {{ item.name }}
            <span class="badge scenario-badge" *ngIf="isHighlighted(item)">{{
              highlightLabel
            }}</span>
          </span>
          <span class="indicator-unit" *ngIf="item.unit">{{ item.unit }}</span>
        </span>
      </label>
    </div>

    <ng-template #noItemsFound>
      <div class="no-data-message">
        <div>No {{ itemNoun }} found</div>
      </div>
    </ng-template>
  </div>

  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn" [disabled]="!selectedCount" (click)="apply()">
      Apply
    </button>
  </div>
</div>
